const UUID_PATTERN = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i

export function extractTicketUuid(value) {
  const raw = String(value || '').trim()
  if (!raw) return ''

  const match = raw.match(UUID_PATTERN)
  return match ? match[0].toLowerCase() : ''
}
